import React, {Fragment} from "react";
import {Transition} from "@headlessui/react";
import {createPortal} from "react-dom";

interface ModalProps {
    show: any,
    setShow: (value: any) => void,
    title?: string,
    children?: any
    onConfirm?: () => void
}

export const Modal = ({show, setShow, title, children, onConfirm}: ModalProps): JSX.Element => {
    const _onConfirm = () => {
        setShow(false);
        onConfirm();
    };

    return createPortal(
        <Transition show={!!show} as="div" className="z-50 fixed" enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100"
                    leaveTo="opacity-0">
            <div onClick={() => setShow(false)} className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity flex justify-center items-center">
                <div onClick={(e) => e.stopPropagation()} className="flex flex-col gap-y-4 bg-white rounded-lg text-left shadow-xl transform w-full md:w-1/4 transition-all sm:my-8 p-5">
                    {title &&
                        <div className="text-2xl font-bold">
                            {title}
                        </div>
                    }
                    {children}
                    <div className="flex justify-between">
                        <button onClick={() => setShow(false)} type="button" className="px-4 py-2 uppercase">
                            Cancel
                        </button>
                        {onConfirm &&
                            <button onClick={_onConfirm} type="button" className="px-4 py-2 bg-primary uppercase">
                                Confirm
                            </button>
                        }
                    </div>
                </div>
            </div>
        </Transition>,
        document.body
    );
};
